export default __webpack_public_path__ + "static/media/root.c1833745.svg";